import React from 'react';

export function ConfettiAnimation({
  showFreeShippingConfetti,
  showDiscountConfetti,
}: {
  showFreeShippingConfetti: boolean;
  showDiscountConfetti: boolean;
}) {
  if (showFreeShippingConfetti && !showDiscountConfetti) {
    return (
      <div className="absolute h-[76px] left-8 overflow-hidden top-[-0.77px] w-[130px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="130" height="76" viewBox="0 0 130 76" fill="none">
          <g clipPath="url(#clip0_2246_18968)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-60.9445 2.41228C-62.9662 2.14006 -64.1153 1.80865 -65.9514 0.870148C-66.4248 1.7614 -66.6724 2.60594 -66.5439 3.53819C-65.3735 4.28764 -63.7538 4.87557 -61.5131 5.45612C-61.8468 4.01036 -61.7835 3.21918 -60.9445 2.41228Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-60.4251 44.4446C-62.4603 44.5842 -63.6526 44.4904 -65.6398 43.94C-65.9244 44.9082 -65.9973 45.7853 -65.6841 46.6727C-64.387 47.1717 -62.6822 47.4222 -60.3705 47.5406C-60.9879 46.1914 -61.0849 45.4036 -60.4251 44.4446Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M107.378 -165.845C109.186 -166.789 110.316 -167.181 112.357 -167.475C112.229 -168.476 111.944 -169.308 111.301 -169.995C109.913 -169.932 108.251 -169.478 106.086 -168.659C107.192 -167.67 107.597 -166.988 107.378 -165.845Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-94.3234 -125.471C-95.5978 -124.726 -95.9888 -123.725 -96.5279 -122.2C-95.7564 -120.836 -95.3199 -119.722 -94.5212 -118.688C-92.9025 -119.141 -91.7236 -119.083 -89.8184 -118.164C-91.0407 -121.387 -92.179 -123.001 -94.3234 -125.471Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M108.537 23.8198C106.513 23.5624 105.362 23.2393 103.519 22.3142C103.052 23.2089 102.81 24.0553 102.946 24.9865C104.122 25.7274 105.746 26.3035 107.99 26.8677C107.646 25.4245 107.704 24.6328 108.537 23.8198Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M49.9555 -127.615C51.0181 -126.59 52.0876 -126.485 53.7021 -126.379C54.8058 -127.491 55.7604 -128.212 56.5386 -129.261C55.6644 -130.697 55.4008 -131.847 55.7695 -133.93C52.9986 -131.881 51.7525 -130.348 49.9555 -127.615Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M125.271 -71.1912C126.428 -72.1082 126.675 -73.1541 126.995 -74.7402C126.039 -75.982 125.451 -77.0241 124.515 -77.9348C122.976 -77.2593 121.801 -77.151 119.785 -77.7934C121.448 -74.7746 122.801 -73.3357 125.271 -71.1912Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M106.095 -59.3813C107.571 -59.355 108.426 -60.0065 109.68 -61.0289C109.731 -62.5948 109.937 -63.7736 109.793 -65.0714C108.175 -65.5267 107.198 -66.1893 106.049 -67.9653C105.417 -64.5774 105.549 -62.6063 106.095 -59.3813Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-24.2018 -38.9313C-24.1995 -36.8914 -24.3733 -35.7081 -25.0562 -33.7624C-24.1094 -33.4133 -23.2392 -33.2815 -22.3327 -33.5343C-21.7476 -34.7949 -21.3829 -36.479 -21.1091 -38.7774C-22.4968 -38.2522 -23.2894 -38.2085 -24.2018 -38.9313Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-155.171 -5.12886C-156.307 -3.43442 -157.111 -2.54924 -158.763 -1.31525C-158.172 -0.497331 -157.523 0.0973792 -156.63 0.393188C-155.441 -0.326708 -154.199 -1.52111 -152.69 -3.27612C-154.135 -3.61422 -154.817 -4.01999 -155.171 -5.12886Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M109.795 -163.196C111.826 -163.015 112.989 -162.735 114.866 -161.88C115.299 -162.792 115.508 -163.646 115.338 -164.572C114.135 -165.268 112.491 -165.783 110.226 -166.262C110.624 -164.833 110.597 -164.04 109.795 -163.196Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.0528 -31.9665C12.8783 -33.4325 12.1168 -34.1907 10.9335 -35.2943C9.37523 -35.1315 8.17925 -35.1763 6.91319 -34.8567C6.6819 -33.1918 6.15809 -32.1341 4.5547 -30.7543C7.99704 -30.5882 9.93193 -30.9869 13.0528 -31.9665Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.3673 13.4736C29.3218 12.8896 30.5055 12.7186 32.5652 12.8182C32.6297 11.8111 32.5078 10.9395 32.007 10.1428C30.6318 9.94147 28.9137 10.0723 26.6326 10.4655C27.5318 11.6458 27.7998 12.3929 27.3673 13.4736Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M82.1579 24.5567C80.2202 25.1945 79.0417 25.3981 76.9801 25.3554C76.9433 26.3639 77.0893 27.2318 77.6119 28.0144C78.9921 28.1777 80.7059 27.9994 82.9753 27.5434C82.0438 26.3884 81.7554 25.649 82.1579 24.5567Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M102.694 -68.3728C104.14 -68.0772 105.1 -68.5616 106.519 -69.3376C106.855 -70.8679 107.274 -71.9891 107.369 -73.2914C105.861 -74.0347 105.022 -74.8647 104.217 -76.8208C102.976 -73.6055 102.746 -71.6434 102.694 -68.3728Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M133.595 -17.4476C134.915 -18.1086 135.37 -19.0821 136.008 -20.5694C135.326 -21.9802 134.963 -23.1206 134.233 -24.2034C132.588 -23.8566 131.416 -23.9909 129.574 -25.0317C130.585 -21.7368 131.616 -20.0516 133.595 -17.4476Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-138.994 -160.371C-138.673 -158.357 -138.66 -157.161 -139.031 -155.132C-138.041 -154.935 -137.161 -154.941 -136.305 -155.332C-135.924 -156.669 -135.827 -158.389 -135.915 -160.702C-137.204 -159.967 -137.98 -159.8 -138.994 -160.371Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-89.0357 -71.2965C-90.4833 -72.7339 -91.1994 -73.6917 -92.0968 -75.5482C-93.0122 -75.1234 -93.7194 -74.5995 -94.1797 -73.7787C-93.6989 -72.4747 -92.7624 -71.0283 -91.3264 -69.2129C-90.7198 -70.567 -90.1917 -71.1596 -89.0357 -71.2965Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M98.6754 -68.4006C96.8746 -69.3589 95.9124 -70.0692 94.5173 -71.5877C93.7636 -70.9167 93.2377 -70.211 93.034 -69.2922C93.8707 -68.1825 95.1848 -67.068 97.0838 -65.7445C97.2737 -67.216 97.6082 -67.9358 98.6754 -68.4006Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M101.872 -22.6717C99.8811 -23.1164 98.7647 -23.5453 97.0159 -24.6379C96.4678 -23.7906 96.1486 -22.9704 96.1966 -22.0306C97.2983 -21.1834 98.8616 -20.4586 101.044 -19.6879C100.836 -21.1569 100.967 -21.9398 101.872 -22.6717Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M68.6269 -92.2123C66.8633 -93.2375 65.9284 -93.9834 64.5912 -95.5531C63.8128 -94.9108 63.2609 -94.2253 63.0228 -93.3149C63.8173 -92.1746 65.0888 -91.0116 66.9368 -89.6178C67.1817 -91.0812 67.543 -91.7879 68.6269 -92.2123Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-36.111 -41.2691C-37.2524 -42.2056 -38.3268 -42.2249 -39.9446 -42.2012C-40.9558 -41.0044 -41.8494 -40.2082 -42.5411 -39.1007C-41.5547 -37.7397 -41.1997 -36.614 -41.4004 -34.5083C-38.8026 -36.7729 -37.6833 -38.4008 -36.111 -41.2691Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.8589 -190.627C36.6702 -192.091 35.9014 -192.842 34.7075 -193.934C33.1508 -193.756 31.9545 -193.789 30.6916 -193.458C30.4765 -191.791 29.963 -190.728 28.3731 -189.332C31.8169 -189.2 33.7478 -189.617 36.8589 -190.627Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-31.8153 -108.198C-33.2808 -108.019 -34.0368 -107.255 -35.1368 -106.069C-34.9695 -104.511 -35.0108 -103.315 -34.6874 -102.05C-33.0219 -101.824 -31.9626 -101.303 -30.5781 -99.7036C-30.4221 -103.146 -30.8265 -105.08 -31.8153 -108.198Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M37.3336 -203.989C36.9892 -205.425 36.1444 -206.089 34.8404 -207.047C33.3118 -206.703 32.1187 -206.608 30.8986 -206.143C30.8633 -204.463 30.4665 -203.351 29.0352 -201.793C32.4734 -202.03 34.3485 -202.652 37.3336 -203.989Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-154.521 -141.444C-156.479 -142.016 -157.566 -142.516 -159.241 -143.718C-159.842 -142.908 -160.214 -142.11 -160.226 -141.169C-159.181 -140.253 -157.668 -139.429 -155.539 -138.519C-155.653 -139.999 -155.472 -140.772 -154.521 -141.444Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M105.755 -141.686C104.409 -142.292 103.367 -142.029 101.811 -141.584C101.148 -140.164 100.493 -139.162 100.115 -137.913C101.423 -136.857 102.059 -135.863 102.416 -133.778C104.332 -136.643 104.987 -138.506 105.755 -141.686Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-18.8838 -24.7214C-20.2616 -26.2258 -20.9315 -27.2165 -21.7399 -29.1135C-22.6744 -28.7325 -23.4056 -28.2428 -23.9043 -27.4447C-23.4859 -26.1194 -22.6191 -24.6302 -21.2707 -22.7488C-20.6006 -24.0726 -20.045 -24.6395 -18.8838 -24.7214Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-37.0828 -13.644C-36.1851 -12.4718 -35.1434 -12.2079 -33.5629 -11.862C-32.3054 -12.7966 -31.2537 -13.3679 -30.3276 -14.2884C-30.9776 -15.8385 -31.0663 -17.0155 -30.3906 -19.02C-33.4365 -17.4076 -34.8976 -16.078 -37.0828 -13.644Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.8717 11.9238C13.8319 11.9475 12.6468 11.7862 10.6941 11.1237C10.3549 12.0742 10.2323 12.9457 10.4946 13.8495C11.7612 14.4214 13.449 14.7683 15.7502 15.0179C15.2105 13.6358 15.1585 12.8438 15.8717 11.9238Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M97.4434 -78.0375C99.1232 -79.1948 100.197 -79.7218 102.187 -80.261C101.939 -81.2391 101.554 -82.0309 100.832 -82.6348C99.4622 -82.403 97.8678 -81.7496 95.8185 -80.6734C97.0373 -79.8272 97.5222 -79.1988 97.4434 -78.0375Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-135.39 -81.4762C-133.64 -80.4271 -132.716 -79.6685 -131.4 -78.0807C-130.613 -78.7123 -130.052 -79.3902 -129.801 -80.2974C-130.58 -81.4484 -131.835 -82.6286 -133.664 -84.0475C-133.929 -82.5876 -134.3 -81.8858 -135.39 -81.4762Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M91.7528 -63.6881C90.252 -62.3064 89.263 -61.6339 87.3681 -60.8207C87.7515 -59.8872 88.2431 -59.1572 89.0425 -58.6606C90.3667 -59.0824 91.8536 -59.9531 93.7316 -61.3063C92.406 -61.973 91.8377 -62.5271 91.7528 -63.6881Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-3.10481 -51.9821C-2.20687 -50.8101 -1.16509 -50.5465 0.415573 -50.201C1.67281 -51.1359 2.72435 -51.7075 3.65019 -52.6283C2.99983 -54.1782 2.91075 -55.3552 3.58595 -57.3598C0.540441 -55.7467 -0.920311 -54.4166 -3.10481 -51.9821Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-88.9117 -39.4274C-90.1708 -40.1983 -91.2377 -40.0699 -92.837 -39.8243C-93.6742 -38.5 -94.4501 -37.5887 -94.9831 -36.3966C-93.8192 -35.184 -93.313 -34.1177 -93.2226 -32.0043C-90.9604 -34.6043 -90.0753 -36.3704 -88.9117 -39.4274Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-115.129 -211.173C-116.065 -210.031 -116.083 -208.957 -116.059 -207.339C-114.862 -206.328 -114.065 -205.435 -112.957 -204.744C-111.597 -205.731 -110.471 -206.087 -108.365 -205.887C-110.631 -208.484 -112.26 -209.602 -115.129 -211.173Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.7923 -72.0647C18.2011 -71.6229 19.2048 -72.0068 20.6964 -72.6337C21.1866 -74.1218 21.7178 -75.1944 21.9451 -76.4802C20.5214 -77.3736 19.7712 -78.2849 19.1699 -80.3129C17.6074 -77.2412 17.178 -75.3128 16.7923 -72.0647Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-91.7057 -195.506C-91.9976 -194.058 -91.5108 -193.1 -90.7311 -191.683C-89.1999 -191.351 -88.0777 -190.935 -86.7751 -190.843C-86.0357 -192.353 -85.2079 -193.194 -83.2539 -194.004C-86.4723 -195.237 -88.435 -195.462 -91.7057 -195.506Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M39.5718 -174.253C38.1269 -174.556 37.1651 -174.077 35.7412 -173.308C35.3973 -171.78 34.9725 -170.661 34.8707 -169.359C36.3743 -168.608 37.2091 -167.773 38.0039 -165.813C39.2617 -169.022 39.5024 -170.982 39.5718 -174.253Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M86.7088 -93.9103C85.4016 -94.5965 84.3454 -94.3981 82.7659 -94.0475C82.0178 -92.6709 81.3037 -91.7105 80.8503 -90.4859C82.0917 -89.3526 82.667 -88.322 82.8965 -86.2192C84.9825 -88.9626 85.7492 -90.7832 86.7088 -93.9103Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-89.8248 -100.574C-88.3772 -100.284 -87.4197 -100.772 -86.0029 -101.553C-85.673 -103.085 -85.2585 -104.208 -85.1685 -105.51C-86.6789 -106.248 -87.5213 -107.075 -88.334 -109.028C-89.5625 -105.808 -89.7852 -103.845 -89.8248 -100.574Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-62.267 12.6786C-61.7448 14.0596 -60.8231 14.6122 -59.409 15.3984C-57.9357 14.8654 -56.7641 14.621 -55.6122 14.006C-55.7885 12.3345 -55.5347 11.1817 -54.3105 9.45659C-57.6917 10.1239 -59.4737 10.9767 -62.267 12.6786Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-40.3338 -57.5062C-41.5524 -56.6727 -41.8718 -55.6466 -42.3019 -54.0869C-41.4361 -52.7811 -40.922 -51.7003 -40.0523 -50.7262C-38.4697 -51.2922 -37.2896 -51.3178 -35.3242 -50.5356C-36.771 -53.6636 -38.0205 -55.1938 -40.3338 -57.5062Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-45.758 -87.1106C-46.2957 -89.0785 -46.4386 -90.2659 -46.2903 -92.3226C-47.2956 -92.411 -48.1699 -92.3097 -48.9782 -91.8278C-49.212 -90.4579 -49.1218 -88.7371 -48.7827 -86.4474C-47.5815 -87.3184 -46.8282 -87.5686 -45.758 -87.1106Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-3.06256 -148.276C-3.62808 -146.316 -4.12429 -145.228 -5.3217 -143.549C-4.50943 -142.95 -3.71029 -142.581 -2.76927 -142.572C-1.85642 -143.62 -1.0375 -145.136 -0.134888 -147.267C-1.61393 -147.149 -2.38731 -147.328 -3.06256 -148.276Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.6407 -92.1523C21.8751 -90.6946 22.667 -89.9682 23.8945 -88.9141C25.4448 -89.1405 26.6416 -89.1447 27.8935 -89.5159C28.0564 -91.1888 28.5365 -92.2672 30.082 -93.7114C26.6358 -93.7365 24.7188 -93.2588 21.6407 -92.1523Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-28.3946 -182.189C-28.0897 -184.206 -27.7397 -185.349 -26.7716 -187.17C-27.6551 -187.658 -28.4955 -187.919 -29.4297 -187.806C-30.198 -186.647 -30.8121 -185.037 -31.4288 -182.806C-29.9779 -183.117 -29.1878 -183.041 -28.3946 -182.189Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-29.8489 -126.552C-28.1747 -127.718 -27.1038 -128.25 -25.1162 -128.799C-25.3696 -129.776 -25.7578 -130.566 -26.4825 -131.166C-27.8516 -130.928 -29.4428 -130.266 -31.4868 -129.18C-30.2638 -128.34 -29.7758 -127.714 -29.8489 -126.552Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-13.1556 -76.5759C-11.6835 -76.6884 -10.8938 -77.4172 -9.74129 -78.5528C-9.83808 -80.1166 -9.74279 -81.3096 -10.0087 -82.588C-11.6623 -82.8894 -12.697 -83.4574 -14.0078 -85.1176C-14.3192 -81.6854 -14.0025 -79.7354 -13.1556 -76.5759Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M41.6118 -195.584C42.4958 -196.767 42.4666 -197.841 42.3699 -199.456C41.1287 -200.412 40.2931 -201.269 39.1554 -201.91C37.8404 -200.863 36.7318 -200.458 34.6192 -200.563C36.9987 -198.07 38.6755 -197.025 41.6118 -195.584Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-75.7619 -73.8225C-74.8423 -74.9774 -74.8387 -76.0521 -74.8862 -77.6694C-76.0977 -78.6628 -76.9068 -79.5447 -78.0244 -80.2201C-79.3707 -79.2138 -80.4911 -78.8424 -82.5996 -79.0122C-80.2971 -76.4478 -78.6529 -75.3525 -75.7619 -73.8225Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-49.2116 -68.9442C-48.6996 -70.9189 -48.2331 -72.0202 -47.0818 -73.7309C-47.9101 -74.3074 -48.7189 -74.6543 -49.6599 -74.6382C-50.5439 -73.5658 -51.3213 -72.028 -52.1656 -69.8728C-50.6903 -70.0312 -49.9124 -69.8737 -49.2116 -68.9442Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M92.8076 -170.63C91.9624 -168.773 91.3129 -167.769 89.8837 -166.283C90.6 -165.572 91.3369 -165.09 92.2664 -164.944C93.3223 -165.848 94.3534 -167.228 95.557 -169.205C94.0765 -169.304 93.3374 -169.593 92.8076 -170.63Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M116.998 -11.8305C115.509 -10.4356 114.526 -9.75435 112.638 -8.9243C113.03 -7.99423 113.528 -7.26866 114.332 -6.77917C115.652 -7.21272 117.132 -8.0966 118.997 -9.46645C117.666 -10.1214 117.093 -10.6704 116.998 -11.8305Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-170.813 46.6348C-171.358 48.6004 -171.844 49.6935 -173.024 51.3843C-172.206 51.9749 -171.403 52.3355 -170.462 52.3355C-169.56 51.2784 -168.756 49.7541 -167.875 47.6136C-169.353 47.7468 -170.128 47.5761 -170.813 46.6348Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-6.32701 33.7919C-6.42057 32.3185 -7.13923 31.5196 -8.25999 30.3526C-9.82486 30.4294 -11.0166 30.3188 -12.2983 30.5684C-12.6208 32.2179 -13.202 33.2453 -14.8789 34.5347C-11.4509 34.89 -9.49701 34.5983 -6.32701 33.7919Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-64.3493 -91.1064C-64.7465 -89.1055 -65.1485 -87.9792 -66.1992 -86.2048C-65.339 -85.6771 -64.5115 -85.3775 -63.573 -85.4479C-62.7524 -86.5695 -62.0651 -88.1496 -61.3466 -90.35C-62.8103 -90.1067 -63.596 -90.219 -64.3493 -91.1064Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M93.4879 -112.977C94.9348 -113.27 95.6285 -114.091 96.632 -115.36C96.343 -116.9 96.2903 -118.096 95.8686 -119.331C94.1905 -119.426 93.0936 -119.862 91.5879 -121.348C91.7025 -117.904 92.2575 -116.008 93.4879 -112.977Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-160.112 -158.415C-161.555 -158.105 -162.239 -157.276 -163.228 -155.995C-162.921 -154.459 -162.854 -153.264 -162.418 -152.033C-160.738 -151.958 -159.636 -151.535 -158.113 -150.067C-158.269 -153.51 -158.846 -155.399 -160.112 -158.415Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35.9083 -87.2979C35.7792 -89.3338 35.8791 -90.5256 36.4398 -92.5099C35.4731 -92.7996 34.5964 -92.8769 33.7074 -92.5683C33.2017 -91.2738 32.9424 -89.5703 32.8121 -87.2593C34.1645 -87.8697 34.9527 -87.9626 35.9083 -87.2979Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M51.0843 -24.5711C51.6588 -23.2111 52.6009 -22.694 54.0439 -21.9622C55.4958 -22.5511 56.6573 -22.8399 57.7849 -23.4984C57.545 -25.1621 57.7547 -26.3237 58.9121 -28.0942C55.5589 -27.2985 53.8107 -26.3783 51.0843 -24.5711Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M57.9411 -46.0443C56.6562 -46.7713 55.5943 -46.6062 54.0045 -46.3056C53.2134 -44.9532 52.4695 -44.0157 51.9778 -42.806C53.1829 -41.6342 53.7255 -40.586 53.8887 -38.477C56.06 -41.1534 56.8837 -42.949 57.9411 -46.0443Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-80.0083 -16.2381C-81.9214 -16.9463 -82.9701 -17.5213 -84.5562 -18.839C-85.2132 -18.073 -85.6397 -17.3031 -85.7184 -16.3654C-84.7405 -15.3779 -83.2888 -14.4496 -81.2295 -13.3926C-81.2386 -14.8763 -81.0036 -15.6345 -80.0083 -16.2381Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-32.2515 -56.2024C-31.3565 -57.3765 -31.3756 -58.451 -31.4572 -60.0669C-32.6894 -61.0346 -33.517 -61.8992 -34.6486 -62.5508C-35.9734 -61.5163 -37.0857 -61.1213 -39.1973 -61.2465C-36.8411 -58.7314 -35.1742 -57.6711 -32.2515 -56.2024Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M94.8983 -138.8C94.2029 -137.498 94.394 -136.44 94.7335 -134.858C96.1048 -134.1 97.0602 -133.38 98.2816 -132.918C99.4235 -134.151 100.458 -134.719 102.562 -134.934C99.8338 -137.039 98.0185 -137.819 94.8983 -138.8Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-64.7063 -167.603C-63.9959 -166.308 -63.006 -165.89 -61.4958 -165.31C-60.1116 -166.044 -58.9857 -166.45 -57.9313 -167.22C-58.3398 -168.85 -58.2499 -170.027 -57.2793 -171.907C-60.5337 -170.773 -62.1788 -169.679 -64.7063 -167.603Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M96.8054 -79.5516C94.8396 -79.0065 93.6527 -78.8591 91.5955 -78.9996C91.5109 -77.994 91.6155 -77.1201 92.1004 -76.3136C93.4713 -76.085 95.1917 -76.1817 97.4801 -76.5295C96.6045 -77.7274 96.3515 -78.4797 96.8054 -79.5516Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M114.209 -8.78484C113.562 -6.85038 113.02 -5.78407 111.753 -4.15724C112.54 -3.5247 113.322 -3.12267 114.262 -3.07356C115.218 -4.08212 116.1 -5.56237 117.092 -7.65393C115.609 -7.59806 114.844 -7.80905 114.209 -8.78484Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-142.685 26.5206C-141.385 28.0923 -140.765 29.1155 -140.053 31.0507C-139.101 30.7172 -138.346 30.2648 -137.808 29.4928C-138.159 28.1481 -138.95 26.6172 -140.202 24.6704C-140.938 25.9589 -141.521 26.4972 -142.685 26.5206Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29.8915 -177.247C29.0461 -176.037 29.1099 -174.964 29.2586 -173.353C30.53 -172.438 31.3928 -171.608 32.5505 -171.004C33.8311 -172.093 34.9261 -172.534 37.041 -172.497C34.5823 -174.912 32.8728 -175.902 29.8915 -177.247Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-170.38 -105.778C-169.766 -103.833 -169.577 -102.652 -169.644 -100.591C-168.636 -100.542 -167.766 -100.678 -166.978 -101.191C-166.798 -102.569 -166.955 -104.285 -167.384 -106.56C-168.55 -105.642 -169.293 -105.363 -170.38 -105.778Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-31.1346 -99.6522C-29.8329 -98.9557 -28.7752 -99.1458 -27.1929 -99.4838C-26.434 -100.854 -25.7123 -101.809 -25.2493 -103.03C-26.4817 -104.173 -27.0488 -105.208 -27.2617 -107.313C-29.3693 -104.586 -30.1504 -102.772 -31.1346 -99.6522Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-108.863 9.49324C-110.323 9.71393 -111.056 10.499 -112.122 11.7165C-111.91 13.2689 -111.917 14.4657 -111.558 15.721C-109.886 15.8996 -108.812 16.3898 -107.383 17.9488C-107.325 14.5029 -107.785 12.5816 -108.863 9.49324Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-137.298 1.19897C-138.786 2.59523 -139.768 3.27733 -141.655 4.10905C-141.262 5.03878 -140.764 5.76392 -139.959 6.25269C-138.639 5.81797 -137.161 4.9328 -135.296 3.56129C-136.628 2.90756 -137.202 2.35904 -137.298 1.19897Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-33.3749 -152.006C-33.6621 -153.454 -34.4799 -154.151 -35.7449 -155.16C-37.2859 -154.878 -38.4818 -154.83 -39.7194 -154.413C-39.8214 -152.736 -40.2619 -151.641 -41.7539 -150.141C-38.309 -150.241 -36.4107 -150.788 -33.3749 -152.006Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.5795 -170.458C19.3437 -169.65 19.0028 -168.631 18.54 -167.081C19.3781 -165.757 19.8694 -164.665 20.7183 -163.673C22.3126 -164.206 23.4929 -164.207 25.4414 -163.383C24.0608 -166.541 22.8438 -168.097 20.5795 -170.458Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M62.7123 -167.805C63.2056 -166.413 64.1155 -165.841 65.5128 -165.026C66.9969 -165.528 68.1734 -165.748 69.3379 -166.339C69.1966 -168.013 69.4745 -169.161 70.7344 -170.86C67.34 -170.263 65.5406 -169.448 62.7123 -167.805Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-147.086 25.8012C-148.686 24.5359 -149.505 23.6647 -150.606 21.921C-151.467 22.4461 -152.111 23.0462 -152.476 23.9136C-151.852 25.1552 -150.758 26.4871 -149.127 28.1293C-148.677 26.7156 -148.219 26.0673 -147.086 25.8012Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-142.152 -112.287C-142.219 -110.812 -141.59 -109.941 -140.602 -108.659C-139.038 -108.567 -137.865 -108.328 -136.564 -108.438C-136.065 -110.043 -135.377 -111.001 -133.57 -112.102C-136.94 -112.826 -138.914 -112.747 -142.152 -112.287Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-6.85367 -15.7306C-4.84033 -15.4021 -3.70088 -15.0387 -1.89169 -14.0494C-1.39364 -14.9271 -1.12256 -15.7644 -1.22501 -16.6999C-2.37403 -17.4817 -3.97671 -18.1146 -6.20036 -18.7574C-5.90711 -17.3029 -5.99248 -16.5138 -6.85367 -15.7306Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-181.906 -11.6861C-182.449 -10.3135 -182.14 -9.28435 -181.624 -7.7509C-180.176 -7.15306 -179.145 -6.5449 -177.879 -6.22408C-176.884 -7.57864 -175.92 -8.26008 -173.854 -8.71138C-176.803 -10.4945 -178.694 -11.0638 -181.906 -11.6861Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-165.603 -64.5152C-164.536 -65.5358 -164.388 -66.6001 -164.217 -68.2091C-165.284 -69.3567 -165.967 -70.3395 -166.983 -71.1592C-168.453 -70.3435 -169.613 -70.1264 -171.68 -70.5786C-169.744 -67.7275 -168.262 -66.4207 -165.603 -64.5152Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M118.478 -51.5656C119.59 -52.5366 119.787 -53.5931 120.03 -55.1927C119.017 -56.3876 118.379 -57.4004 117.401 -58.2655C115.896 -57.5174 114.727 -57.3532 112.684 -57.8989C114.488 -54.9627 115.909 -53.59 118.478 -51.5656Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M45.4494 -20.9521C47.354 -20.2213 48.3958 -19.6339 49.9661 -18.2975C50.6322 -19.0557 51.0678 -19.8204 51.1576 -20.7572C50.1915 -21.7562 48.7509 -22.7016 46.7043 -23.783C46.6958 -22.2992 46.4518 -21.5439 45.4494 -20.9521Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-26.2811 -201.241C-27.9912 -200.129 -29.0784 -199.63 -31.0823 -199.144C-30.8599 -198.16 -30.4968 -197.358 -29.7913 -196.735C-28.4153 -196.931 -26.8041 -197.541 -24.7269 -198.563C-25.9228 -199.441 -26.3908 -200.082 -26.2811 -201.241Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M90.0911 -94.9404C91.5404 -94.6589 92.495 -95.1526 93.907 -95.9425C94.2278 -97.4761 94.6356 -98.6013 94.7177 -99.9045C93.203 -100.633 92.3556 -101.455 91.5312 -103.403C90.3221 -100.176 90.1111 -98.2113 90.0911 -94.9404Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-81.9969 -163.849C-83.1013 -164.829 -84.1742 -164.89 -85.7917 -164.928C-86.8483 -163.771 -87.7719 -163.01 -88.5058 -161.93C-87.5725 -160.532 -87.2613 -159.394 -87.543 -157.297C-84.8598 -159.46 -83.6786 -161.044 -81.9969 -163.849Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-170.125 -74.7458C-168.099 -74.9803 -166.904 -74.9424 -164.893 -74.4855C-164.654 -75.4659 -164.622 -76.3455 -164.976 -77.2173C-166.295 -77.6551 -168.01 -77.8256 -170.325 -77.8358C-169.645 -76.517 -169.511 -75.7346 -170.125 -74.7458Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.6022 -37.1729C20.41 -38.0437 19.3362 -38.0026 17.7223 -37.888C16.78 -36.6363 15.9325 -35.7912 15.3042 -34.6465C16.3655 -33.3431 16.7832 -32.2392 16.7012 -30.1254C19.1676 -32.5325 20.1936 -34.2207 21.6022 -37.1729Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-42.1398 15.4627C-40.1347 15.0868 -38.9396 15.0409 -36.9018 15.3559C-36.732 14.3611 -36.7619 13.4815 -37.1764 12.6366C-38.5229 12.2923 -40.2452 12.2423 -42.555 12.3942C-41.7845 13.6622 -41.5963 14.4333 -42.1398 15.4627Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-12.3882 -2.93602C-11.8496 -4.90359 -11.3683 -5.99848 -10.194 -7.69348C-11.0144 -8.28116 -11.8186 -8.63886 -12.7596 -8.63545C-13.658 -7.57511 -14.4561 -6.04795 -15.3294 -3.90431C-13.8521 -4.04284 -13.0764 -3.87486 -12.3882 -2.93602Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-116.885 -197.257C-118.728 -196.382 -119.872 -196.033 -121.923 -195.818C-121.833 -194.813 -121.58 -193.97 -120.964 -193.259C-119.574 -193.269 -117.896 -193.66 -115.701 -194.396C-116.77 -195.425 -117.148 -196.123 -116.885 -197.257Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-35.9881 -135.53C-35.3926 -137.481 -34.8798 -138.561 -33.6568 -140.222C-34.4598 -140.833 -35.2532 -141.214 -36.194 -141.238C-37.1228 -140.204 -37.9648 -138.7 -38.9 -136.583C-37.4193 -136.679 -36.6488 -136.488 -35.9881 -135.53Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-50.8566 -38.9241C-49.3822 -38.9989 -48.5741 -39.7073 -47.3929 -40.8131C-47.4497 -42.3788 -47.324 -43.569 -47.5571 -44.8538C-49.2025 -45.1974 -50.2223 -45.7916 -51.4902 -47.4848C-51.8893 -44.0616 -51.6225 -42.1042 -50.8566 -38.9241Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M42.0294 -126.999C42.8869 -128.2 42.8338 -129.274 42.7012 -130.886C41.439 -131.815 40.5845 -132.653 39.4329 -133.268C38.1415 -132.192 37.0422 -131.762 34.9277 -131.821C37.3622 -129.381 39.0618 -128.374 42.0294 -126.999Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M92.2817 -155.327C94.2706 -155.781 95.463 -155.873 97.5116 -155.638C97.6425 -156.639 97.5784 -157.516 97.1313 -158.344C95.7725 -158.636 94.0495 -158.619 91.7474 -158.377C92.5667 -157.14 92.7847 -156.377 92.2817 -155.327Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M86.609 6.60526C84.749 5.7675 83.7422 5.12198 82.2502 3.69861C81.5422 4.41774 81.0639 5.15653 80.9211 6.08669C81.829 7.13892 83.2136 8.16456 85.1955 9.36032C85.2882 7.87945 85.5746 7.13922 86.609 6.60526Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-44.7073 -54.8368C-45.8917 -56.4977 -46.4359 -57.5627 -47.0073 -59.544C-47.9812 -59.2796 -48.7667 -58.8826 -49.3588 -58.1511C-49.1049 -56.7848 -48.4259 -55.2011 -47.3166 -53.1695C-46.4903 -54.4018 -45.8698 -54.8968 -44.7073 -54.8368Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-36.9054 26.4217C-36.3036 28.3709 -36.1219 29.553 -36.2028 31.6134C-35.1951 31.6689 -34.3246 31.539 -33.5325 31.0309C-33.3437 29.6541 -33.4902 27.9372 -33.9041 25.6598C-35.0761 26.5697 -35.8208 26.8444 -36.9054 26.4217Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-111.715 67.6284C-110.346 67.0756 -109.814 66.1419 -109.059 64.7107C-109.625 63.2496 -109.896 62.0837 -110.536 60.9458C-112.203 61.1592 -113.361 60.9311 -115.113 59.7457C-114.371 63.1111 -113.479 64.8737 -111.715 67.6284Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-119.614 61.4936C-118.96 60.1703 -119.183 59.1193 -119.572 57.5486C-120.966 56.8336 -121.943 56.1428 -123.178 55.7189C-124.281 56.9871 -125.298 57.5869 -127.395 57.8668C-124.602 59.8864 -122.763 60.6093 -119.614 61.4936Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35.359 -106.904C35.5088 -104.87 35.421 -103.677 34.8806 -101.687C35.8502 -101.408 36.7277 -101.339 37.6135 -101.657C38.1059 -102.956 38.3478 -104.662 38.4547 -106.975C37.1086 -106.35 36.3213 -106.25 35.359 -106.904Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-62.2196 -7.08005C-62.8885 -9.00722 -63.111 -10.1823 -63.1015 -12.2443C-64.1105 -12.2648 -64.9759 -12.1049 -65.75 -11.5698C-65.891 -10.1872 -65.6852 -8.47639 -65.1927 -6.21469C-64.0529 -7.16461 -63.3182 -7.46493 -62.2196 -7.08005Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M67.3605 -55.2137C67.8935 -53.2446 68.0336 -52.0569 67.8805 -50.0006C68.8855 -49.9098 69.76 -50.009 70.5695 -50.489C70.8065 -51.8584 70.7204 -53.5793 70.3867 -55.8698C69.1835 -55.0017 68.4296 -54.7532 67.3605 -55.2137Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-109.961 -163.163C-111.236 -162.418 -111.627 -161.417 -112.166 -159.892C-111.395 -158.528 -110.958 -157.413 -110.16 -156.38C-108.541 -156.833 -107.362 -156.775 -105.457 -155.856C-106.679 -159.078 -107.817 -160.693 -109.961 -163.163Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.9126 -60.5232C14.2279 -61.1936 14.6762 -62.1703 15.3027 -63.662C14.6114 -65.068 14.2401 -66.2058 13.5026 -67.2833C11.8604 -66.925 10.6868 -67.0509 8.83791 -68.0786C9.87174 -64.7909 10.9147 -63.1131 12.9126 -60.5232Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-140.523 -67.071C-140.327 -69.1015 -140.039 -70.2623 -139.17 -72.1324C-140.079 -72.5719 -140.932 -72.7876 -141.859 -72.624C-142.564 -71.4263 -143.09 -69.7856 -143.586 -67.5246C-142.154 -67.9125 -141.361 -67.879 -140.523 -67.071Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M82.5328 -99.0001C81.1423 -98.5038 80.5726 -97.5926 79.76 -96.1935C80.2654 -94.7105 80.4878 -93.5345 81.0812 -92.3713C82.7558 -92.5163 83.9036 -92.241 85.6055 -90.9848C85.0015 -94.3778 84.1822 -96.1755 82.5328 -99.0001Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.33403 -159.544C0.284818 -161.02 -0.409507 -161.84 -1.49467 -163.04C-3.06114 -163.011 -4.249 -163.157 -5.53764 -162.946C-5.90963 -161.307 -6.52144 -160.297 -8.23631 -159.059C-4.82056 -158.601 -2.85878 -158.834 0.33403 -159.544Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M70.4006 -42.9153C71.7729 -44.4247 72.6983 -45.1823 74.5135 -46.1606C74.0488 -47.0564 73.4943 -47.7398 72.654 -48.1635C71.3725 -47.6258 69.9687 -46.6266 68.2183 -45.112C69.5977 -44.5656 70.213 -44.0641 70.4006 -42.9153Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-38.7538 -159.808C-39.0927 -158.371 -38.6374 -157.397 -37.9044 -155.955C-36.3849 -155.573 -35.2768 -155.121 -33.9779 -154.987C-33.1896 -156.472 -32.3348 -157.286 -30.3555 -158.032C-33.532 -159.368 -35.4863 -159.658 -38.7538 -159.808Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.85213 -31.2673C2.28165 -33.2615 2.70194 -34.3812 3.78119 -36.1383C2.92969 -36.6799 2.10711 -36.9928 1.16766 -36.9377C0.328963 -35.8295 -0.383878 -34.2607 -1.13792 -32.0723C0.329503 -32.2919 1.11333 -32.1669 1.85213 -31.2673Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-147.982 -16.3298C-147.682 -14.3119 -147.682 -13.116 -148.074 -11.0915C-147.086 -10.8841 -146.206 -10.8806 -145.346 -11.2628C-144.951 -12.5952 -144.836 -14.3145 -144.9 -16.6283C-146.196 -15.9064 -146.974 -15.7477 -147.982 -16.3298Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M37.3628 -64.6537C36.9507 -66.0714 36.0753 -66.6947 34.7274 -67.5897C33.2168 -67.1741 32.0295 -67.0225 30.8329 -66.4999C30.8772 -64.8197 30.5337 -63.6904 29.1777 -62.0668C32.6009 -62.4664 34.4444 -63.1765 37.3628 -64.6537Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-105.111 -86.6731C-103.212 -87.4186 -102.047 -87.6879 -99.9861 -87.7609C-100.006 -88.7699 -100.2 -89.6283 -100.766 -90.3803C-102.153 -90.4659 -103.854 -90.1918 -106.095 -89.6092C-105.1 -88.5083 -104.77 -87.7862 -105.111 -86.6731Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-24.7615 -54.5527C-22.7421 -54.2638 -21.5957 -53.9229 -19.7674 -52.9693C-19.2867 -53.8566 -19.0321 -54.6991 -19.153 -55.6324C-20.3171 -56.3914 -21.9319 -56.9927 -24.1678 -57.5917C-23.846 -56.1433 -23.9159 -55.3526 -24.7615 -54.5527Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-114.075 -155.203C-112.683 -154.711 -111.666 -155.058 -110.153 -155.63C-109.609 -157.1 -109.039 -158.152 -108.766 -159.429C-110.156 -160.374 -110.873 -161.311 -111.4 -163.36C-113.073 -160.347 -113.572 -158.435 -114.075 -155.203Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M63.1215 -122.193C61.9657 -123.874 61.4397 -124.948 60.9024 -126.939C59.924 -126.691 59.1319 -126.308 58.5274 -125.587C58.7578 -124.216 59.4097 -122.621 60.484 -120.571C61.3313 -121.789 61.9602 -122.273 63.1215 -122.193Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-70.4147 -97.6499C-72.0119 -98.919 -72.8292 -99.792 -73.9258 -101.538C-74.7888 -101.015 -75.4339 -100.417 -75.8009 -99.55C-75.1793 -98.3069 -74.0891 -96.9726 -72.4617 -95.3266C-72.008 -96.7393 -71.5485 -97.3865 -70.4147 -97.6499Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-106.327 -43.0489C-104.88 -43.3435 -104.187 -44.1648 -103.185 -45.4349C-103.475 -46.9745 -103.529 -48.1701 -103.952 -49.4055C-105.63 -49.499 -106.727 -49.934 -108.234 -51.4184C-108.117 -47.9741 -107.56 -46.0786 -106.327 -43.0489Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-132.681 -94.3282C-134.615 -94.9763 -135.682 -95.5182 -137.308 -96.7857C-137.941 -95.9996 -138.343 -95.2168 -138.392 -94.277C-137.384 -93.3206 -135.904 -92.4381 -133.813 -91.4459C-133.868 -92.9286 -133.657 -93.6937 -132.681 -94.3282Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M117.557 -109.529C118.189 -110.863 117.948 -111.91 117.533 -113.474C116.127 -114.165 115.138 -114.84 113.896 -115.243C112.815 -113.956 111.808 -113.339 109.717 -113.024C112.543 -111.052 114.394 -110.36 117.557 -109.529Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-68.372 -56.2829C-68.8308 -57.6861 -69.7264 -58.2801 -71.1032 -59.1299C-72.5992 -58.6645 -73.7808 -58.4736 -74.9594 -57.9117C-74.8594 -56.2338 -75.1654 -55.0938 -76.4668 -53.4262C-73.0588 -53.939 -71.2398 -54.7098 -68.372 -56.2829Z"
              fill="#FFC700"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-77.5641 -25.6989C-76.3016 -26.4643 -75.9264 -27.4713 -75.4114 -29.0051C-76.2043 -30.3564 -76.6583 -31.4638 -77.4731 -32.4842C-79.0845 -32.0059 -80.2642 -32.0451 -82.1837 -32.934C-80.9107 -29.7313 -79.7471 -28.1348 -77.5641 -25.6989Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-38.1675 -240.635C-37.9767 -238.604 -38.0403 -237.41 -38.5405 -235.409C-37.5654 -235.149 -36.6868 -235.098 -35.8076 -235.434C-35.3414 -236.743 -35.134 -238.454 -35.0738 -240.768C-36.4071 -240.116 -37.1921 -240 -38.1675 -240.635Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-35.3009 -148.539C-34.3525 -149.67 -34.3219 -150.744 -34.3287 -152.362C-35.5148 -153.386 -36.3015 -154.288 -37.4017 -154.991C-38.7729 -154.019 -39.9023 -153.676 -42.0058 -153.899C-39.7686 -151.277 -38.1525 -150.141 -35.3009 -148.539Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M115.854 -57.6413C114.631 -58.4688 113.559 -58.3891 111.951 -58.2166C111.054 -56.9318 110.237 -56.0568 109.65 -54.8902C110.758 -53.6259 111.215 -52.5376 111.209 -50.4223C113.587 -52.9165 114.552 -54.6405 115.854 -57.6413Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-84.9171 7.98317C-84.6627 9.43748 -83.8609 10.1529 -82.6191 11.1901C-81.072 10.9424 -79.8753 10.9217 -78.6287 10.5333C-78.4888 8.85832 -78.0236 7.77349 -76.498 6.30815C-79.9443 6.33044 -81.8545 6.83444 -84.9171 7.98317Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-83.8307 -99.2255C-82.5062 -100.777 -81.6049 -101.563 -79.8211 -102.598C-80.3136 -103.478 -80.8892 -104.144 -81.7423 -104.542C-83.0064 -103.964 -84.3783 -102.922 -86.0806 -101.353C-84.6847 -100.85 -84.0541 -100.368 -83.8307 -99.2255Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M43.8781 -24.5259C42.6842 -23.6574 42.3948 -22.6225 42.0101 -21.0509C42.9135 -19.7708 43.4587 -18.7054 44.3562 -17.7569C45.9218 -18.3686 47.1007 -18.4284 49.0879 -17.7036C47.551 -20.7882 46.2576 -22.2816 43.8781 -24.5259Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-24.0527 -38.771C-23.1006 -39.8994 -23.0665 -40.9734 -23.0681 -42.5914C-24.2508 -43.6189 -25.0346 -44.5234 -26.1326 -45.2302C-27.5069 -44.2626 -28.6374 -43.9232 -30.7402 -44.1528C-28.5115 -41.5241 -26.8991 -40.3825 -24.0527 -38.771Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.1328 -76.4966C11.1906 -75.8726 10.0107 -75.6774 7.94942 -75.7347C7.90551 -74.7265 8.04531 -73.8575 8.56238 -73.0712C9.94133 -72.8982 11.6564 -73.0643 13.9289 -73.5042C13.0057 -74.6658 12.7225 -75.4072 13.1328 -76.4966Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-39.7088 -132.375C-41.1652 -132.133 -41.8874 -131.337 -42.9352 -130.104C-42.7006 -128.555 -42.6902 -127.358 -42.3123 -126.108C-40.6386 -125.954 -39.5578 -125.48 -38.1055 -123.942C-38.0984 -127.388 -38.5862 -129.303 -39.7088 -132.375Z"
              fill="#61BA47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-20.9144 0.828094C-21.9961 1.83289 -22.16 2.89495 -22.3544 4.50122C-21.3047 5.66436 -20.6362 6.6571 -19.632 7.49167C-18.1505 6.69758 -16.9873 6.49752 -14.9277 6.98003C-16.8218 4.1008 -18.2841 2.77245 -20.9144 0.828094Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-64.5965 17.7399C-63.4656 16.0421 -62.664 15.1546 -61.0156 13.9157C-61.6091 13.0995 -62.2597 12.5067 -63.1539 12.2136C-64.3405 12.937 -65.579 14.1351 -67.083 15.8945C-65.6373 16.2284 -64.9539 16.6321 -64.5965 17.7399Z"
              fill="#F74F9E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-143.305 -57.5059C-141.856 -57.7883 -141.156 -58.6038 -140.143 -59.8654C-140.421 -61.4074 -140.465 -62.6034 -140.877 -63.8424C-142.554 -63.9499 -143.648 -64.3941 -145.143 -65.8911C-145.054 -62.4459 -144.513 -60.5457 -143.305 -57.5059Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-129.758 -137.955C-131.635 -138.754 -132.655 -139.379 -134.176 -140.771C-134.869 -140.037 -135.332 -139.288 -135.455 -138.356C-134.526 -137.322 -133.12 -136.326 -131.114 -135.171C-131.052 -136.654 -130.781 -137.4 -129.758 -137.955Z"
              fill="#FF5257"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-165.512 -127.307C-166.966 -127.05 -167.679 -126.246 -168.714 -125.003C-168.463 -123.456 -168.44 -122.259 -168.05 -121.013C-166.374 -120.877 -165.289 -120.414 -163.82 -118.891C-163.849 -122.337 -164.357 -124.246 -165.512 -127.307Z"
              fill="#A550A7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-72.8907 -119.929C-71.6653 -118.298 -71.0947 -117.247 -70.4742 -115.281C-69.5071 -115.569 -68.7318 -115.986 -68.1581 -116.732C-68.4459 -118.091 -69.1642 -119.658 -70.3237 -121.661C-71.1191 -120.408 -71.7271 -119.898 -72.8907 -119.929Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-134.612 -94.5723C-136.073 -94.7848 -137.003 -94.2466 -138.376 -93.3908C-138.624 -91.8438 -138.978 -90.7006 -138.999 -89.395C-137.451 -88.7389 -136.566 -87.9581 -135.65 -86.0512C-134.595 -89.332 -134.477 -91.3041 -134.612 -94.5723Z"
              fill="#007AFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M116.326 -105.948C114.301 -106.194 113.148 -106.511 111.3 -107.427C110.838 -106.529 110.601 -105.682 110.741 -104.751C111.921 -104.017 113.548 -103.449 115.796 -102.897C115.444 -104.338 115.497 -105.13 116.326 -105.948Z"
              fill="#61BA47"
            />
          </g>
          <defs>
            <clipPath id="clip0_2246_18968">
              <rect width="130" height="76" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    );
  }
  if (showDiscountConfetti) {
    return (
      <div className="absolute top-0 left-1/2 -translate-x-1/2">
        <svg xmlns="http://www.w3.org/2000/svg" width="330" height="50" viewBox="0 0 330 50" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M89.9469 -11.9227C87.4526 -12.2585 86.0349 -12.6674 83.7697 -13.8252C83.1857 -12.7257 82.8802 -11.6837 83.0387 -10.5336C84.4826 -9.60899 86.4809 -8.88365 89.2453 -8.16742C88.8336 -9.95107 88.9118 -10.9272 89.9469 -11.9227Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M297.608 -219.504C299.839 -220.669 301.233 -221.154 303.751 -221.515C303.594 -222.75 303.242 -223.777 302.449 -224.625C300.736 -224.547 298.685 -223.986 296.014 -222.976C297.38 -221.757 297.879 -220.915 297.608 -219.504Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.7654 -169.695C47.1931 -168.775 46.7107 -167.54 46.0456 -165.658C46.9974 -163.976 47.5359 -162.601 48.5213 -161.326C50.5183 -161.885 51.9728 -161.814 54.3233 -160.68C52.8153 -164.655 51.4109 -166.647 48.7654 -169.695Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M226.765 -172.344C228.076 -171.08 229.396 -170.95 231.387 -170.819C232.749 -172.191 233.927 -173.082 234.887 -174.375C233.808 -176.146 233.483 -177.566 233.938 -180.136C230.52 -177.607 228.982 -175.716 226.765 -172.344Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M319.685 -102.729C321.112 -103.86 321.416 -105.151 321.811 -107.107C320.632 -108.64 319.906 -109.925 318.752 -111.049C316.853 -110.215 315.403 -110.082 312.916 -110.874C314.967 -107.15 316.638 -105.375 319.685 -102.729Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M296.025 -88.1604C297.847 -88.128 298.901 -88.9317 300.448 -90.193C300.51 -92.1249 300.766 -93.5792 300.587 -95.1803C298.591 -95.742 297.386 -96.5596 295.968 -98.7506C295.188 -94.5709 295.351 -92.1391 296.025 -88.1604Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M135.275 -62.9305C135.278 -60.4138 135.064 -58.9539 134.221 -56.5535C135.389 -56.1228 136.463 -55.9603 137.581 -56.2721C138.303 -57.8273 138.753 -59.905 139.091 -62.7406C137.379 -62.0927 136.401 -62.0388 135.275 -62.9305Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-26.3028 -21.2265C-27.7042 -19.136 -28.6964 -18.0439 -30.7346 -16.5215C-30.0053 -15.5125 -29.2049 -14.7788 -28.1028 -14.4138C-26.6361 -15.302 -25.1039 -16.7755 -23.2419 -18.9407C-25.0243 -19.3578 -25.8659 -19.8584 -26.3028 -21.2265Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M300.592 -216.238C303.098 -216.015 304.533 -215.67 306.848 -214.615C307.382 -215.739 307.64 -216.794 307.43 -217.936C305.946 -218.795 303.918 -219.43 301.124 -220.021C301.615 -218.258 301.581 -217.279 300.592 -216.238Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M163.44 7.39615C165.207 6.9547 166.017 5.9048 167.184 4.28506C166.742 2.40322 166.611 0.932482 166.023 -0.567322C163.95 -0.591576 162.574 -1.06821 160.636 -2.81607C160.967 1.42279 161.756 3.72889 163.44 7.39615Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M181.239 -54.3401C181.024 -56.1488 180.084 -57.0843 178.625 -58.4457C176.702 -58.2449 175.227 -58.3002 173.665 -57.9059C173.379 -55.8519 172.733 -54.5469 170.755 -52.8448C175.002 -52.6397 177.389 -53.1317 181.239 -54.3401Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M198.899 1.72162C201.311 1.00106 202.771 0.790168 205.312 0.913025C205.392 -0.329454 205.241 -1.40479 204.623 -2.38773C202.927 -2.63606 200.807 -2.47462 197.993 -1.98953C199.102 -0.533431 199.433 0.388317 198.899 1.72162Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M277.633 11.025C275.242 11.8119 273.788 12.063 271.245 12.0104C271.2 13.2546 271.38 14.3254 272.024 15.2909C273.727 15.4923 275.842 15.2723 278.641 14.7097C277.492 13.2848 277.136 12.3725 277.633 11.025Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M291.829 -99.2554C293.614 -98.8907 294.797 -99.4882 296.549 -100.446C296.963 -102.334 297.48 -103.717 297.597 -105.323C295.737 -106.241 294.702 -107.265 293.708 -109.678C292.177 -105.711 291.893 -103.29 291.829 -99.2554Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M329.952 -36.4281C331.58 -37.2437 332.142 -38.4447 332.928 -40.2795C332.087 -42.0201 331.639 -43.4271 330.739 -44.7629C328.71 -44.3351 327.263 -44.5008 324.991 -45.7848C326.238 -41.7199 327.51 -39.6408 329.952 -36.4281Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-6.34531 -212.755C-5.94948 -210.269 -5.93326 -208.794 -6.39057 -206.291C-5.16949 -206.048 -4.08373 -206.056 -3.02781 -206.538C-2.55763 -208.187 -2.43775 -210.31 -2.54698 -213.163C-4.13682 -212.256 -5.09415 -212.05 -6.34531 -212.755Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M55.289 -102.86C53.5031 -104.633 52.6196 -105.815 51.5125 -108.105C50.3831 -107.581 49.5107 -106.935 48.9428 -105.922C49.536 -104.313 50.6913 -102.529 52.463 -100.289C53.2114 -101.96 53.8629 -102.691 55.289 -102.86Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M286.873 -99.288C284.651 -100.47 283.464 -101.347 281.743 -103.22C280.813 -102.392 280.164 -101.522 279.913 -100.388C280.945 -99.019 282.566 -97.644 284.909 -96.0111C285.144 -97.8266 285.556 -98.7146 286.873 -99.288Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M290.816 -42.8716C288.36 -43.4204 286.982 -43.9494 284.825 -45.2975C284.149 -44.2521 283.755 -43.2402 283.814 -42.0807C285.173 -41.0356 287.102 -40.1414 289.795 -39.1905C289.538 -41.0029 289.699 -41.9687 290.816 -42.8716Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M249.803 -128.666C247.627 -129.931 246.474 -130.851 244.824 -132.787C243.864 -131.995 243.183 -131.149 242.889 -130.026C243.869 -128.619 245.438 -127.185 247.718 -125.465C248.02 -127.27 248.466 -128.142 249.803 -128.666Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120.584 -65.8144C119.175 -66.9698 117.85 -66.9936 115.854 -66.9643C114.607 -65.4878 113.504 -64.5056 112.651 -63.1392C113.868 -61.4601 114.306 -60.0713 114.058 -57.4734C117.263 -60.2674 118.644 -62.2757 120.584 -65.8144Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M210.609 -250.08C210.376 -251.887 209.427 -252.813 207.955 -254.16C206.034 -253.941 204.558 -253.982 203 -253.572C202.735 -251.516 202.101 -250.204 200.14 -248.483C204.388 -248.319 206.771 -248.834 210.609 -250.08Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M197.408 -5.41415C198.603 -4.03961 199.906 -3.79447 201.878 -3.48962C203.355 -4.73676 204.606 -5.52079 205.676 -6.72528C204.757 -8.58414 204.558 -10.0266 205.236 -12.5466C201.609 -10.3279 199.912 -8.57865 197.408 -5.41415Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M125.885 -148.386C124.077 -148.166 123.144 -147.223 121.787 -145.76C121.993 -143.838 121.942 -142.362 122.341 -140.801C124.396 -140.522 125.703 -139.88 127.411 -137.907C127.603 -142.154 127.104 -144.54 125.885 -148.386Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M211.193 -266.563C210.769 -268.334 209.726 -269.154 208.118 -270.335C206.232 -269.911 204.76 -269.794 203.254 -269.22C203.211 -267.147 202.721 -265.775 200.956 -263.854C205.197 -264.146 207.511 -264.913 211.193 -266.563Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-25.5014 -189.4C-27.9172 -190.105 -29.2577 -190.722 -31.3239 -192.206C-32.066 -191.206 -32.5241 -190.222 -32.5396 -189.061C-31.2505 -187.93 -29.3834 -186.914 -26.7575 -185.792C-26.8974 -187.617 -26.6739 -188.57 -25.5014 -189.4Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M295.606 -189.701C293.945 -190.449 292.659 -190.125 290.74 -189.576C289.922 -187.825 289.114 -186.588 288.648 -185.046C290.261 -183.744 291.046 -182.518 291.486 -179.945C293.85 -183.48 294.658 -185.779 295.606 -189.701Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M141.836 -45.3971C140.137 -47.253 139.31 -48.4753 138.313 -50.8157C137.16 -50.3457 136.258 -49.7415 135.643 -48.7569C136.159 -47.1218 137.228 -45.2846 138.892 -42.9634C139.718 -44.5966 140.404 -45.296 141.836 -45.3971Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M119.383 -31.7334C120.491 -30.2873 121.776 -29.9617 123.726 -29.535C125.277 -30.688 126.575 -31.3928 127.717 -32.5285C126.915 -34.4409 126.806 -35.893 127.639 -38.3659C123.882 -36.3767 122.079 -34.7363 119.383 -31.7334Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M184.715 -0.18988C182.198 -0.160641 180.736 -0.359721 178.327 -1.177C177.908 -0.00440574 177.757 1.07081 178.081 2.18582C179.643 2.89137 181.726 3.3194 184.565 3.62738C183.899 1.92224 183.835 0.94513 184.715 -0.18988Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M285.353 -111.176C287.425 -112.604 288.75 -113.254 291.205 -113.919C290.899 -115.126 290.425 -116.103 289.534 -116.848C287.844 -116.562 285.877 -115.756 283.348 -114.428C284.852 -113.384 285.45 -112.609 285.353 -111.176Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-1.89761 -115.423C0.260795 -114.128 1.40147 -113.192 3.02462 -111.233C3.99568 -112.013 4.68811 -112.849 4.99706 -113.968C4.03615 -115.388 2.48726 -116.844 0.231014 -118.595C-0.0957718 -116.794 -0.553336 -115.928 -1.89761 -115.423Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M278.332 -93.4765C276.48 -91.7719 275.26 -90.9423 272.922 -89.9389C273.395 -88.7872 274.002 -87.8867 274.988 -87.274C276.622 -87.7944 278.456 -88.8686 280.773 -90.5381C279.138 -91.3606 278.437 -92.0442 278.332 -93.4765Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M161.304 -79.0295C162.412 -77.5837 163.697 -77.2585 165.647 -76.8322C167.198 -77.9856 168.495 -78.6908 169.638 -79.8268C168.835 -81.7389 168.725 -83.191 169.558 -85.6642C165.801 -83.674 163.999 -82.0331 161.304 -79.0295Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M55.4428 -63.542C53.8894 -64.4931 52.5731 -64.3347 50.6001 -64.0316C49.5672 -62.3978 48.6101 -61.2735 47.9524 -59.8029C49.3884 -58.3069 50.0128 -56.9913 50.1243 -54.384C52.9153 -57.5916 54.0073 -59.7705 55.4428 -63.542Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.0995 -275.428C21.9448 -274.019 21.9217 -272.694 21.952 -270.698C23.4292 -269.451 24.4119 -268.349 25.7788 -267.497C27.4572 -268.714 28.8458 -269.153 31.4438 -268.907C28.6482 -272.11 26.6391 -273.49 23.0995 -275.428Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M185.852 -103.809C187.59 -103.264 188.829 -103.738 190.669 -104.512C191.274 -106.347 191.929 -107.671 192.209 -109.257C190.453 -110.359 189.527 -111.483 188.786 -113.985C186.858 -110.196 186.328 -107.817 185.852 -103.809Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M51.995 -256.101C51.6349 -254.315 52.2354 -253.133 53.1973 -251.384C55.0864 -250.975 56.4709 -250.462 58.0779 -250.349C58.9902 -252.211 60.0115 -253.249 62.4221 -254.249C58.4514 -255.769 56.03 -256.047 51.995 -256.101Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M213.956 -229.883C212.173 -230.257 210.986 -229.666 209.23 -228.718C208.805 -226.832 208.281 -225.452 208.156 -223.846C210.011 -222.919 211.041 -221.889 212.021 -219.471C213.573 -223.43 213.87 -225.849 213.956 -229.883Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M272.108 -130.757C270.495 -131.604 269.192 -131.359 267.244 -130.926C266.321 -129.228 265.44 -128.043 264.88 -126.532C266.412 -125.134 267.122 -123.863 267.405 -121.268C269.978 -124.653 270.924 -126.899 272.108 -130.757Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M54.3143 -138.981C56.1003 -138.623 57.2815 -139.225 59.0294 -140.189C59.4364 -142.079 59.9479 -143.464 60.0588 -145.071C58.1955 -145.981 57.1562 -147.001 56.1536 -149.41C54.6379 -145.438 54.3632 -143.016 54.3143 -138.981Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M88.3137 0.745636C88.9579 2.44933 90.095 3.13107 91.8396 4.1011C93.6572 3.44348 95.1027 3.14203 96.5238 2.38327C96.3063 0.321037 96.6194 -1.10114 98.1297 -3.22943C93.9583 -2.40619 91.7598 -1.35409 88.3137 0.745636Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M115.373 -85.8497C113.869 -84.8214 113.475 -83.5555 112.945 -81.6312C114.013 -80.0202 114.647 -78.6869 115.72 -77.4851C117.672 -78.1833 119.128 -78.2149 121.553 -77.2499C119.768 -81.1089 118.227 -82.9968 115.373 -85.8497Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M108.683 -122.374C108.019 -124.802 107.843 -126.267 108.026 -128.804C106.786 -128.913 105.707 -128.788 104.71 -128.194C104.421 -126.504 104.533 -124.381 104.951 -121.556C106.433 -122.63 107.362 -122.939 108.683 -122.374Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M161.355 -197.835C160.657 -195.417 160.045 -194.074 158.568 -192.003C159.57 -191.264 160.556 -190.809 161.717 -190.798C162.843 -192.09 163.853 -193.961 164.967 -196.591C163.142 -196.445 162.188 -196.665 161.355 -197.835Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M191.833 -128.591C192.122 -126.793 193.099 -125.897 194.614 -124.596C196.526 -124.876 198.003 -124.881 199.547 -125.339C199.748 -127.403 200.341 -128.733 202.247 -130.515C197.996 -130.546 195.631 -129.956 191.833 -128.591Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M130.104 -239.668C130.48 -242.156 130.912 -243.567 132.106 -245.813C131.016 -246.415 129.979 -246.737 128.827 -246.597C127.879 -245.169 127.121 -243.182 126.36 -240.43C128.15 -240.813 129.125 -240.719 130.104 -239.668Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M128.31 -171.028C130.375 -172.466 131.696 -173.123 134.149 -173.8C133.836 -175.005 133.357 -175.98 132.463 -176.72C130.774 -176.426 128.811 -175.61 126.289 -174.27C127.798 -173.233 128.4 -172.461 128.31 -171.028Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M148.905 -109.376C150.721 -109.515 151.696 -110.414 153.117 -111.815C152.998 -113.744 153.116 -115.216 152.788 -116.793C150.747 -117.165 149.471 -117.866 147.854 -119.914C147.47 -115.68 147.86 -113.274 148.905 -109.376Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M216.471 -256.194C217.562 -257.653 217.526 -258.978 217.406 -260.971C215.875 -262.15 214.844 -263.207 213.441 -263.998C211.818 -262.706 210.451 -262.206 207.844 -262.336C210.78 -259.261 212.849 -257.972 216.471 -256.194Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M71.6656 -105.978C72.8002 -107.403 72.8046 -108.729 72.746 -110.724C71.2514 -111.95 70.2531 -113.038 68.8743 -113.871C67.2133 -112.63 65.8311 -112.171 63.2298 -112.381C66.0704 -109.217 68.0989 -107.866 71.6656 -105.978Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M104.423 -99.9626C105.054 -102.399 105.63 -103.757 107.05 -105.868C106.029 -106.579 105.031 -107.007 103.87 -106.987C102.779 -105.664 101.82 -103.767 100.778 -101.108C102.598 -101.304 103.558 -101.109 104.423 -99.9626Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M279.633 -225.413C278.59 -223.122 277.789 -221.883 276.025 -220.05C276.909 -219.173 277.818 -218.579 278.965 -218.398C280.268 -219.513 281.54 -221.216 283.025 -223.656C281.198 -223.777 280.286 -224.134 279.633 -225.413Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M309.475 -29.4964C307.639 -27.7754 306.426 -26.9349 304.097 -25.9109C304.581 -24.7634 305.195 -23.8683 306.187 -23.2644C307.816 -23.7993 309.641 -24.8897 311.942 -26.5797C310.3 -27.3877 309.593 -28.0651 309.475 -29.4964Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-45.5997 42.6366C-46.2729 45.0616 -46.8715 46.4103 -48.3277 48.4962C-47.3181 49.2249 -46.3277 49.6697 -45.1667 49.6697C-44.0536 48.3655 -43.0623 46.4849 -41.9754 43.8442C-43.7985 44.0085 -44.7548 43.7979 -45.5997 42.6366Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M85.7456 -127.301C85.2556 -124.832 84.7595 -123.443 83.4633 -121.254C84.5245 -120.602 85.5455 -120.233 86.7032 -120.32C87.7157 -121.704 88.5636 -123.653 89.45 -126.368C87.6443 -126.067 86.6749 -126.206 85.7456 -127.301Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M280.472 -154.279C282.257 -154.641 283.113 -155.654 284.351 -157.219C283.994 -159.119 283.929 -160.594 283.409 -162.119C281.339 -162.236 279.986 -162.774 278.128 -164.607C278.269 -160.358 278.954 -158.018 280.472 -154.279Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-32.3994 -210.336C-34.1801 -209.954 -35.0239 -208.931 -36.2434 -207.351C-35.8644 -205.455 -35.782 -203.981 -35.2437 -202.463C-33.1722 -202.37 -31.8126 -201.848 -29.9335 -200.037C-30.1251 -204.285 -30.8374 -206.616 -32.3994 -210.336Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M209.436 -122.601C209.277 -125.113 209.4 -126.583 210.092 -129.031C208.899 -129.389 207.818 -129.484 206.721 -129.103C206.097 -127.506 205.777 -125.405 205.616 -122.554C207.285 -123.307 208.257 -123.421 209.436 -122.601Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M228.159 -45.213C228.868 -43.5352 230.03 -42.8972 231.81 -41.9944C233.601 -42.7209 235.034 -43.0773 236.425 -43.8897C236.13 -45.9421 236.388 -47.3752 237.816 -49.5595C233.679 -48.5778 231.522 -47.4427 228.159 -45.213Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M236.618 -71.7099C235.033 -72.6069 233.723 -72.4032 231.761 -72.0323C230.785 -70.3638 229.867 -69.2072 229.261 -67.7148C230.748 -66.2692 231.417 -64.9759 231.618 -62.374C234.297 -65.6759 235.313 -67.8912 236.618 -71.7099Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M66.4274 -34.9307C64.0672 -35.8044 62.7734 -36.5138 60.8166 -38.1394C60.006 -37.1944 59.4798 -36.2446 59.3827 -35.0877C60.5892 -33.8694 62.3802 -32.7242 64.9208 -31.4201C64.9095 -33.2507 65.1995 -34.186 66.4274 -34.9307Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M125.347 -84.2384C126.451 -85.687 126.427 -87.0125 126.327 -89.0061C124.806 -90.2 123.785 -91.2666 122.389 -92.0705C120.755 -90.7943 119.383 -90.307 116.778 -90.4614C119.684 -87.3585 121.741 -86.0503 125.347 -84.2384Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M282.213 -186.145C281.355 -184.538 281.591 -183.234 282.01 -181.282C283.702 -180.347 284.88 -179.458 286.387 -178.888C287.796 -180.41 289.072 -181.111 291.669 -181.376C288.302 -183.973 286.063 -184.935 282.213 -186.145Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M85.3036 -221.672C86.18 -220.076 87.4013 -219.56 89.2645 -218.843C90.9722 -219.749 92.3612 -220.25 93.662 -221.2C93.1581 -223.212 93.269 -224.664 94.4664 -226.982C90.4514 -225.583 88.4218 -224.234 85.3036 -221.672Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M284.564 -113.049C282.139 -112.376 280.675 -112.194 278.137 -112.367C278.033 -111.127 278.162 -110.049 278.76 -109.054C280.451 -108.772 282.574 -108.891 285.397 -109.32C284.317 -110.798 284.004 -111.726 284.564 -113.049Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M306.035 -25.7375C305.237 -23.351 304.568 -22.0355 303.005 -20.0284C303.975 -19.248 304.941 -18.7521 306.101 -18.6915C307.28 -19.9357 308.368 -21.7619 309.592 -24.3423C307.763 -24.2734 306.819 -24.5337 306.035 -25.7375Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-10.8978 17.8184C-9.29341 19.7574 -8.52938 21.0197 -7.65097 23.4072C-6.4759 22.9957 -5.54453 22.4376 -4.88062 21.4851C-5.31396 19.8262 -6.28973 17.9376 -7.83449 15.5358C-8.74227 17.1254 -9.46196 17.7894 -10.8978 17.8184Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M202.012 -233.573C200.969 -232.079 201.048 -230.756 201.232 -228.768C202.8 -227.639 203.865 -226.615 205.293 -225.87C206.873 -227.213 208.224 -227.757 210.833 -227.711C207.8 -230.691 205.69 -231.912 202.012 -233.573Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-45.0664 -145.401C-44.3083 -143.001 -44.0746 -141.544 -44.1577 -139.001C-42.9141 -138.941 -41.8413 -139.108 -40.8681 -139.742C-40.6463 -141.442 -40.8409 -143.559 -41.3699 -146.365C-42.8085 -145.233 -43.7249 -144.888 -45.0664 -145.401Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M126.723 -137.843C128.329 -136.984 129.634 -137.218 131.586 -137.635C132.522 -139.326 133.413 -140.504 133.984 -142.011C132.464 -143.421 131.764 -144.698 131.501 -147.294C128.901 -143.93 127.937 -141.692 126.723 -137.843Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.8282 -3.18552C29.0272 -2.91325 28.1219 -1.94468 26.8073 -0.442596C27.0687 1.47257 27.06 2.94912 27.5035 4.49783C29.5654 4.71817 30.8902 5.32287 32.654 7.24625C32.7248 2.99501 32.1577 0.624629 30.8282 -3.18552Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-4.25256 -13.4206C-6.08739 -11.698 -7.29939 -10.8565 -9.62723 -9.83035C-9.14303 -8.68334 -8.52771 -7.78873 -7.53558 -7.18573C-5.90703 -7.72205 -4.08314 -8.81412 -1.78272 -10.5062C-3.42602 -11.3127 -4.13379 -11.9894 -4.25256 -13.4206Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M123.96 -202.436C123.606 -204.223 122.597 -205.083 121.036 -206.327C119.135 -205.979 117.66 -205.92 116.133 -205.406C116.007 -203.336 115.464 -201.985 113.623 -200.135C117.873 -200.259 120.215 -200.934 123.96 -202.436Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M190.524 -225.197C189 -224.2 188.579 -222.943 188.008 -221.03C189.042 -219.397 189.648 -218.051 190.696 -216.827C192.663 -217.484 194.119 -217.484 196.523 -216.469C194.819 -220.364 193.318 -222.284 190.524 -225.197Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M242.504 -221.924C243.113 -220.208 244.235 -219.502 245.959 -218.496C247.79 -219.115 249.242 -219.387 250.678 -220.115C250.504 -222.182 250.847 -223.597 252.401 -225.693C248.213 -224.957 245.993 -223.952 242.504 -221.924Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-16.3278 16.935C-18.3018 15.3739 -19.3127 14.2991 -20.6705 12.1478C-21.7337 12.7957 -22.5279 13.5361 -22.9782 14.6062C-22.2078 16.138 -20.859 17.7811 -18.8466 19.8072C-18.2909 18.063 -17.7258 17.2633 -16.3278 16.935Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-10.242 -153.43C-10.3236 -151.61 -9.54867 -150.535 -8.32958 -148.954C-6.40005 -148.84 -4.95313 -148.545 -3.34785 -148.68C-2.73242 -150.661 -1.88266 -151.843 0.345852 -153.201C-3.81122 -154.094 -6.24655 -153.996 -10.242 -153.43Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M156.68 -34.3068C159.164 -33.9015 160.57 -33.4532 162.802 -32.2327C163.416 -33.3155 163.751 -34.3485 163.624 -35.5026C162.207 -36.4671 160.23 -37.248 157.486 -38.041C157.848 -36.2466 157.743 -35.273 156.68 -34.3068Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-59.2879 -29.3139C-59.9586 -27.6204 -59.5769 -26.3508 -58.9401 -24.459C-57.1534 -23.7214 -55.8817 -22.9711 -54.3201 -22.5753C-53.0924 -24.2464 -51.9034 -25.0871 -49.3538 -25.6439C-52.9922 -27.8438 -55.3261 -28.5461 -59.2879 -29.3139Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-39.173 -94.4955C-37.8569 -95.7546 -37.6739 -97.0677 -37.4632 -99.0527C-38.7792 -100.469 -39.6218 -101.681 -40.8758 -102.692C-42.6888 -101.686 -44.1202 -101.418 -46.6696 -101.976C-44.2809 -98.4585 -42.453 -96.8464 -39.173 -94.4955Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M311.303 -78.5143C312.675 -79.7122 312.917 -81.0157 313.218 -82.989C311.968 -84.4632 311.181 -85.7128 309.974 -86.78C308.117 -85.8571 306.675 -85.6545 304.154 -86.3277C306.38 -82.7053 308.133 -81.0118 311.303 -78.5143Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M221.207 -40.7489C223.556 -39.8472 224.842 -39.1226 226.779 -37.4738C227.601 -38.4092 228.138 -39.3526 228.249 -40.5083C227.057 -41.7408 225.28 -42.9072 222.755 -44.2413C222.744 -42.4108 222.443 -41.479 221.207 -40.7489Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M132.71 -263.174C130.601 -261.801 129.259 -261.187 126.787 -260.587C127.061 -259.373 127.509 -258.383 128.38 -257.615C130.077 -257.856 132.065 -258.609 134.628 -259.869C133.152 -260.953 132.575 -261.744 132.71 -263.174Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M276.281 -132.03C278.069 -131.683 279.246 -132.292 280.988 -133.266C281.384 -135.158 281.887 -136.546 281.988 -138.154C280.12 -139.053 279.074 -140.067 278.057 -142.47C276.565 -138.488 276.305 -136.065 276.281 -132.03Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M63.9722 -217.041C62.6096 -218.249 61.286 -218.324 59.2904 -218.372C57.9869 -216.945 56.8474 -216.006 55.942 -214.673C57.0934 -212.948 57.4774 -211.544 57.1299 -208.957C60.4402 -211.626 61.8974 -213.579 63.9722 -217.041Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-44.7523 -107.118C-42.2523 -107.407 -40.7775 -107.361 -38.2968 -106.797C-38.0018 -108.007 -37.9626 -109.092 -38.3998 -110.167C-40.0271 -110.707 -42.1425 -110.918 -44.9981 -110.93C-44.1594 -109.303 -43.9945 -108.338 -44.7523 -107.118Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M191.786 -60.7615C190.315 -61.8359 188.991 -61.7852 186.999 -61.6438C185.837 -60.0995 184.791 -59.0569 184.016 -57.6447C185.326 -56.0367 185.841 -54.6747 185.74 -52.067C188.783 -55.0366 190.048 -57.1194 191.786 -60.7615Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M113.147 4.17856C115.621 3.71479 117.095 3.65814 119.609 4.04672C119.819 2.81944 119.782 1.73429 119.271 0.691986C117.61 0.267157 115.485 0.205453 112.635 0.392822C113.586 1.95721 113.818 2.90855 113.147 4.17856Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M149.852 -18.5232C150.516 -20.9506 151.11 -22.3014 152.559 -24.3925C151.547 -25.1175 150.554 -25.5588 149.393 -25.5546C148.285 -24.2465 147.301 -22.3624 146.223 -19.7177C148.046 -19.8886 149.003 -19.6814 149.852 -18.5232Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.9297 -258.259C18.6561 -257.18 17.2448 -256.75 14.7147 -256.484C14.8251 -255.244 15.1374 -254.204 15.8977 -253.327C17.6122 -253.34 19.6826 -253.822 22.3902 -254.729C21.0722 -256 20.6052 -256.86 20.9297 -258.259Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120.736 -182.109C121.471 -184.516 122.103 -185.849 123.612 -187.898C122.621 -188.652 121.643 -189.122 120.482 -189.151C119.336 -187.876 118.297 -186.021 117.143 -183.409C118.97 -183.527 119.921 -183.292 120.736 -182.109Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M102.392 -62.9246C104.211 -63.0168 105.208 -63.8908 106.666 -65.255C106.596 -67.1867 106.751 -68.6551 106.463 -70.2401C104.433 -70.664 103.175 -71.3972 101.611 -73.4861C101.118 -69.2628 101.448 -66.8479 102.392 -62.9246Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M216.989 -171.581C218.047 -173.064 217.981 -174.388 217.818 -176.377C216.261 -177.523 215.206 -178.556 213.786 -179.316C212.192 -177.989 210.836 -177.458 208.228 -177.53C211.231 -174.521 213.328 -173.278 216.989 -171.581Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M278.983 -206.529C281.437 -207.088 282.908 -207.202 285.435 -206.912C285.597 -208.146 285.518 -209.229 284.966 -210.251C283.29 -210.611 281.164 -210.59 278.324 -210.292C279.335 -208.765 279.604 -207.824 278.983 -206.529Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M271.984 -6.75424C269.69 -7.78779 268.448 -8.5842 266.607 -10.3402C265.733 -9.45303 265.143 -8.54157 264.967 -7.39401C266.087 -6.09585 267.795 -4.83048 270.241 -3.35526C270.355 -5.18223 270.708 -6.09548 271.984 -6.75424Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M109.979 -82.551C108.518 -84.6001 107.846 -85.914 107.142 -88.3583C105.94 -88.0322 104.971 -87.5424 104.24 -86.64C104.554 -84.9543 105.391 -83.0005 106.76 -80.494C107.779 -82.0144 108.545 -82.6251 109.979 -82.551Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M119.604 17.6946C120.346 20.0994 120.571 21.5578 120.471 24.0998C121.714 24.1681 122.788 24.0079 123.765 23.3812C123.998 21.6825 123.817 19.5643 123.307 16.7546C121.861 17.8772 120.942 18.2161 119.604 17.6946Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M208.758 -146.793C208.942 -144.284 208.834 -142.812 208.167 -140.357C209.364 -140.012 210.446 -139.927 211.539 -140.319C212.147 -141.923 212.445 -144.027 212.577 -146.88C210.916 -146.11 209.945 -145.985 208.758 -146.793Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M88.375 -23.6325C87.5498 -26.0101 87.2752 -27.4598 87.2869 -30.0038C86.0422 -30.0291 84.9745 -29.8318 84.0195 -29.1716C83.8455 -27.4658 84.0994 -25.3552 84.707 -22.5649C86.1132 -23.7368 87.0197 -24.1074 88.375 -23.6325Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M248.237 -83.019C248.895 -80.5896 249.068 -79.1243 248.879 -76.5874C250.119 -76.4754 251.198 -76.5978 252.196 -77.1899C252.489 -78.8794 252.382 -81.0025 251.971 -83.8284C250.486 -82.7573 249.556 -82.4508 248.237 -83.019Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.4738 -216.199C27.9015 -215.28 27.419 -214.045 26.7536 -212.163C27.7053 -210.481 28.2437 -209.106 29.2289 -207.831C31.226 -208.39 32.6804 -208.318 35.0309 -207.184C33.5232 -211.16 32.1191 -213.152 29.4738 -216.199Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M181.066 -89.5708C182.689 -90.3979 183.242 -91.6028 184.015 -93.4433C183.162 -95.1778 182.704 -96.5816 181.794 -97.9109C179.768 -97.4688 178.32 -97.6241 176.039 -98.892C177.315 -94.836 178.601 -92.7661 181.066 -89.5708Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-8.23085 -97.6448C-7.98918 -100.15 -7.63399 -101.582 -6.56226 -103.889C-7.68303 -104.431 -8.73573 -104.697 -9.87907 -104.496C-10.7487 -103.018 -11.3982 -100.994 -12.0099 -98.2045C-10.243 -98.683 -9.26462 -98.6417 -8.23085 -97.6448Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M266.956 -137.037C265.241 -136.424 264.538 -135.3 263.535 -133.574C264.159 -131.745 264.433 -130.294 265.165 -128.859C267.231 -129.037 268.647 -128.698 270.747 -127.148C270.002 -131.334 268.991 -133.552 266.956 -137.037Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M253.728 6.52603C251.474 7.64406 250.07 8.0989 247.545 8.40759C247.676 9.64565 248.007 10.68 248.782 11.5443C250.496 11.5021 252.558 10.9845 255.249 10.0304C253.91 8.78294 253.428 7.93038 253.728 6.52603Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M165.547 -211.732C165.486 -213.552 164.63 -214.564 163.291 -216.045C161.358 -216.008 159.893 -216.189 158.303 -215.928C157.844 -213.906 157.089 -212.661 154.974 -211.133C159.188 -210.568 161.608 -210.855 165.547 -211.732Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M251.988 -67.8464C253.681 -69.7086 254.823 -70.6433 257.062 -71.8501C256.489 -72.9553 255.805 -73.7985 254.768 -74.3212C253.187 -73.6579 251.455 -72.4251 249.296 -70.5565C250.998 -69.8824 251.757 -69.2637 251.988 -67.8464Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M117.322 -212.057C116.904 -210.284 117.465 -209.083 118.37 -207.304C120.244 -206.833 121.611 -206.275 123.214 -206.109C124.186 -207.941 125.241 -208.945 127.683 -209.866C123.764 -211.515 121.353 -211.871 117.322 -212.057Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M167.419 -53.4773C167.949 -55.9376 168.468 -57.319 169.799 -59.4867C168.749 -60.1549 167.734 -60.541 166.575 -60.4729C165.54 -59.1057 164.661 -57.1703 163.73 -54.4704C165.541 -54.7413 166.508 -54.5871 167.419 -53.4773Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-17.4311 -35.0439C-17.0615 -32.5545 -17.0608 -31.079 -17.5445 -28.5814C-16.3261 -28.3255 -15.2403 -28.3212 -14.1793 -28.7927C-13.6918 -30.4365 -13.5495 -32.5576 -13.6287 -35.4122C-15.228 -34.5216 -16.1874 -34.3258 -17.4311 -35.0439Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M211.23 -94.6646C210.722 -96.4136 209.642 -97.1826 207.979 -98.2867C206.115 -97.774 204.651 -97.587 203.174 -96.9423C203.229 -94.8693 202.805 -93.4762 201.132 -91.4731C205.355 -91.966 207.63 -92.8421 211.23 -94.6646Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.4582 -121.832C37.8009 -122.751 39.2384 -123.083 41.7808 -123.174C41.7563 -124.418 41.5165 -125.477 40.8185 -126.405C39.1072 -126.511 37.0084 -126.173 34.2447 -125.454C35.4719 -124.096 35.8784 -123.205 35.4582 -121.832Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M134.586 -82.2013C137.077 -81.8449 138.492 -81.4244 140.747 -80.2479C141.34 -81.3426 141.655 -82.382 141.505 -83.5334C140.069 -84.4699 138.077 -85.2117 135.319 -85.9507C135.716 -84.1637 135.629 -83.1882 134.586 -82.2013Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.3998 -206.373C26.117 -205.765 27.3716 -206.194 29.2385 -206.9C29.9093 -208.713 30.612 -210.012 30.9496 -211.587C29.2341 -212.752 28.3499 -213.909 27.699 -216.436C25.6355 -212.718 25.0202 -210.36 24.3998 -206.373Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M231.283 4.83823C229.989 3.55635 228.671 3.40878 226.681 3.25146C225.301 4.60495 224.112 5.47986 223.135 6.76056C224.189 8.54593 224.496 9.9696 224.006 12.533C227.458 10.0508 229.021 8.18016 231.283 4.83823Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M243.009 -165.652C241.583 -167.726 240.934 -169.051 240.271 -171.507C239.064 -171.202 238.087 -170.729 237.341 -169.839C237.625 -168.148 238.429 -166.18 239.755 -163.651C240.8 -165.153 241.576 -165.751 243.009 -165.652Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M78.2627 -135.373C76.2922 -136.938 75.2838 -138.015 73.931 -140.17C72.8663 -139.524 72.0704 -138.786 71.6177 -137.717C72.3845 -136.183 73.7295 -134.537 75.7373 -132.506C76.297 -134.249 76.8639 -135.048 78.2627 -135.373Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.9575 -68.0067C35.7423 -68.3701 36.5972 -69.3834 37.8339 -70.9503C37.4756 -72.8497 37.4093 -74.3248 36.8877 -75.849C34.8172 -75.9643 33.4635 -76.501 31.6043 -78.3323C31.7494 -74.0829 32.4362 -71.7444 33.9575 -68.0067Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.44219 -131.274C-0.944139 -132.074 -2.25947 -132.742 -4.26606 -134.306C-5.04672 -133.336 -5.54299 -132.37 -5.60392 -131.211C-4.36 -130.031 -2.53411 -128.942 0.0459213 -127.718C-0.0224643 -129.547 0.238118 -130.491 1.44219 -131.274Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M310.166 -150.026C310.946 -151.672 310.648 -152.964 310.137 -154.894C308.402 -155.746 307.182 -156.578 305.65 -157.075C304.315 -155.488 303.074 -154.727 300.493 -154.338C303.98 -151.905 306.263 -151.051 310.166 -150.026Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M80.7823 -84.3368C80.2162 -86.068 79.1114 -86.8008 77.4127 -87.8492C75.567 -87.275 74.1094 -87.0396 72.6552 -86.3463C72.7786 -84.2763 72.4011 -82.8699 70.7956 -80.8125C75.0001 -81.4451 77.2442 -82.3961 80.7823 -84.3368Z"
            fill="#FFC700"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M69.4431 -46.6057C71.0006 -47.55 71.4635 -48.7923 72.0989 -50.6846C71.1207 -52.3517 70.5606 -53.7179 69.5553 -54.9767C67.5673 -54.3867 66.1119 -54.4351 63.7438 -55.5316C65.3143 -51.5805 66.7499 -49.6109 69.4431 -46.6057Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M118.048 -311.776C118.284 -309.27 118.205 -307.797 117.588 -305.329C118.791 -305.008 119.875 -304.945 120.96 -305.359C121.535 -306.974 121.791 -309.085 121.865 -311.939C120.22 -311.136 119.252 -310.992 118.048 -311.776Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M121.582 -198.151C122.752 -199.547 122.79 -200.872 122.782 -202.868C121.318 -204.131 120.348 -205.244 118.99 -206.111C117.299 -204.912 115.905 -204.489 113.31 -204.764C116.07 -201.53 118.064 -200.128 121.582 -198.151Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M308.065 -86.0092C306.556 -87.0301 305.234 -86.9318 303.249 -86.7189C302.143 -85.1339 301.136 -84.0544 300.412 -82.6152C301.778 -81.0554 302.342 -79.7127 302.335 -77.1031C305.269 -80.1801 306.459 -82.3071 308.065 -86.0092Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M177.947 16.5927C178.634 14.1715 179.24 12.8263 180.708 10.7486C179.702 10.0143 178.715 9.56384 177.554 9.55734C176.433 10.8552 175.431 12.7301 174.329 15.3647C176.154 15.2107 177.109 15.4267 177.947 16.5927Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M60.3707 -5.05188C60.6846 -3.25767 61.6738 -2.37505 63.2059 -1.09546C65.1145 -1.40106 66.5908 -1.42653 68.1289 -1.90573C68.3015 -3.9722 68.8754 -5.31056 70.7575 -7.11838C66.5058 -7.09088 64.1491 -6.46909 60.3707 -5.05188Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M61.7111 -137.316C63.3451 -139.23 64.457 -140.2 66.6577 -141.476C66.0502 -142.563 65.3401 -143.384 64.2876 -143.874C62.728 -143.162 61.0355 -141.876 58.9353 -139.941C60.6575 -139.32 61.4354 -138.725 61.7111 -137.316Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M219.268 -45.1565C217.795 -44.085 217.438 -42.8082 216.963 -40.8693C218.078 -39.29 218.75 -37.9756 219.858 -36.8055C221.789 -37.5601 223.243 -37.6339 225.695 -36.7396C223.799 -40.5452 222.203 -42.3876 219.268 -45.1565Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M135.46 -62.729C136.635 -64.1212 136.677 -65.4463 136.675 -67.4424C135.216 -68.71 134.249 -69.8259 132.894 -70.698C131.199 -69.5042 129.804 -69.0854 127.21 -69.3687C129.959 -66.1256 131.949 -64.7173 135.46 -62.729Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M181.336 -109.276C178.94 -108.506 177.485 -108.265 174.942 -108.336C174.887 -107.092 175.06 -106.02 175.698 -105.05C177.399 -104.837 179.515 -105.042 182.319 -105.584C181.18 -107.017 180.83 -107.932 181.336 -109.276Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M116.146 -178.215C114.349 -177.916 113.458 -176.934 112.165 -175.413C112.455 -173.502 112.468 -172.026 112.934 -170.483C114.999 -170.293 116.332 -169.708 118.124 -167.811C118.132 -172.062 117.531 -174.424 116.146 -178.215Z"
            fill="#61BA47"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M139.331 -13.8814C137.997 -12.6418 137.794 -11.3315 137.555 -9.34979C138.85 -7.91481 139.674 -6.69005 140.913 -5.66043C142.741 -6.64011 144.176 -6.8869 146.717 -6.29163C144.38 -9.84378 142.576 -11.4826 139.331 -13.8814Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M68.7316 6.98135C70.1268 4.88676 71.1158 3.79176 73.1494 2.26334C72.4171 1.25642 71.6146 0.525104 70.5113 0.163422C69.0473 1.05591 67.5194 2.53396 65.6639 4.70465C67.4475 5.11649 68.2906 5.61462 68.7316 6.98135Z"
            fill="#F74F9E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-11.6651 -85.8493C-9.87731 -86.1977 -9.01394 -87.2038 -7.76416 -88.7603C-8.10655 -90.6627 -8.16051 -92.1382 -8.66931 -93.6667C-10.7387 -93.7994 -12.0879 -94.3474 -13.9317 -96.1942C-13.8222 -91.9438 -13.155 -89.5996 -11.6651 -85.8493Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.05153 -185.1C2.73585 -186.086 1.47746 -186.856 -0.399281 -188.573C-1.25415 -187.668 -1.82518 -186.745 -1.97754 -185.594C-0.830752 -184.319 0.903387 -183.09 3.37862 -181.665C3.45501 -183.494 3.78937 -184.415 5.05153 -185.1Z"
            fill="#FF5257"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-39.0584 -171.96C-40.852 -171.643 -41.7327 -170.652 -43.0093 -169.117C-42.7 -167.209 -42.6717 -165.733 -42.1895 -164.196C-40.1227 -164.027 -38.7832 -163.456 -36.9717 -161.577C-37.0075 -165.829 -37.6339 -168.185 -39.0584 -171.96Z"
            fill="#A550A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M75.2075 -162.862C76.7192 -160.85 77.4233 -159.553 78.1888 -157.127C79.3819 -157.483 80.3384 -157.997 81.0462 -158.917C80.6911 -160.595 79.8049 -162.527 78.3744 -164.999C77.3931 -163.453 76.6431 -162.824 75.2075 -162.862Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-0.937542 -131.574C-2.74 -131.837 -3.88747 -131.172 -5.58157 -130.117C-5.8874 -128.208 -6.32434 -126.798 -6.34951 -125.187C-4.44035 -124.378 -3.34819 -123.414 -2.21868 -121.062C-0.916799 -125.109 -0.771388 -127.542 -0.937542 -131.574Z"
            fill="#007AFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M308.647 -145.61C306.148 -145.914 304.726 -146.305 302.446 -147.435C301.876 -146.328 301.584 -145.282 301.757 -144.134C303.212 -143.228 305.219 -142.528 307.993 -141.846C307.558 -143.625 307.624 -144.602 308.647 -145.61Z"
            fill="#61BA47"
          />
        </svg>
      </div>
    );
  }
}
